// extracted by mini-css-extract-plugin
var _1 = "Project_addButton__8ZAw8";
var _2 = "Project_addButtonIcon__+XY8r";
var _3 = "Project_board__Pwv7m";
var _4 = "Project_boardProgress__GEnnE";
var _5 = "Project_boardProgressBar__27zUu";
var _6 = "Project_boardProgresses__Cqz0c";
var _7 = "Project_boardTitle__JJtDs";
var _8 = "Project_boardWrapper__UoK9V";
var _9 = "Project_boardsWrapper__gqvRY";
var _a = "Project_boardsWrapperEmpty__bgHZ8";
var _b = "Project_header__n3CNs";
var _c = "Project_headerButton__oKANk";
var _d = "Project_headerButtonGroup__cMhiK";
var _e = "Project_headerDetails__1Dhu4";
var _f = "Project_headerText__Z+ggc";
var _10 = "Project_info__wA3Be";
var _11 = "Project_notification__w4Sek";
var _12 = "Project_title__kdDy-";
var _13 = "Project_wrapper__XCZxv";
export { _1 as "addButton", _2 as "addButtonIcon", _3 as "board", _4 as "boardProgress", _5 as "boardProgressBar", _6 as "boardProgresses", _7 as "boardTitle", _8 as "boardWrapper", _9 as "boardsWrapper", _a as "boardsWrapperEmpty", _b as "header", _c as "headerButton", _d as "headerButtonGroup", _e as "headerDetails", _f as "headerText", _10 as "info", _11 as "notification", _12 as "title", _13 as "wrapper" }
